import React from "react";
import { Settings } from "lucide-react";

const ManagePapersTab = () => {
  return (
    <div className="bg-white rounded-lg shadow p-8 text-center">
      <Settings className="w-16 h-16 text-gray-400 mx-auto mb-4" />
      <h3 className="text-xl font-semibold text-gray-700 mb-2">Manage Papers</h3>
      <p className="text-gray-500">
        This tab will allow you to view, edit, and manage generated papers (active, closed, opened).
      </p>
      <p className="text-sm text-gray-400 mt-4">Coming soon...</p>
    </div>
  );
};

export default ManagePapersTab;
